import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import OptionChooser from 'Components/OptionChooser';
import { withFormContext } from 'Containers/FormContextHandler';
import * as React from 'react';
import colors from '../../../../../../config/theme/colors';

import type { IFormContext } from 'Containers/FormContextHandler';

const PerformanceRatingForm = ({
  editing,
  formData,
  fm,
}: IFormContext<IDocumentWithTypeV2<'performanceRating'>>): React.JSX.Element => (
  <React.Fragment>
    <FormRow title="general.date">
      <InputHandler
        type="PartialDate"
        editing={!!editing}
        name="date"
        formData={formData}
        dateDefault="now"
        isNotCancellable={true}
      />
    </FormRow>
    <FormRow title="diagnosis.sleepApnea.performanceRating.rating" bottomMargin>
      <OptionChooser
        formData={formData}
        name="rating"
        opts={[0, 1, 2, 3, 4]}
        optionFormatter={(name: string | number): React.JSX.Element => (
          <span>{fm(`diagnosis.sleepApnea.performanceRating.opts.${name}`)}</span>
        )}
      />
    </FormRow>
    <span
      style={{
        fontStyle: 'italic',
        color: colors.darkGray,
      }}
    >
      Oken M, Creech R, Tormey D, et al. Toxicity and response criteria of the Eastern Cooperative Oncology Group. Am J
      Clin Oncol. 1982;5:649-655.
    </span>
  </React.Fragment>
);

export default withFormContext(PerformanceRatingForm);
